export class PricingItem {
    code: string;
    impact: number;
    base: number;
    newPrice: number;
}
